




















import {Vue, Component, Prop} from 'vue-property-decorator'
import {VehicleSlot} from '@/lib/kepler/interfaces'
import Utils from '@/utils'

import VehicleInstructions from '../../VehicleInstructions.vue'
import VehicleQuickSummary from './VehicleQuickSummary.vue'
import VehicleFeatures from './VehicleFeatures.vue'
import VehicleFares from './VehicleFares.vue'

@Component({
  components: {
    AccordionContent: Utils.loadComponent('proxy/Accordion/AccordionContent'),
    Accordion: Utils.loadComponent('proxy/Accordion/Accordion'),
    Container: Utils.loadComponent('proxy/Container'),
    Divider: Utils.loadComponent('proxy/Divider'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Chip: Utils.loadComponent('proxy/Chip'),
    Btn: Utils.loadComponent('proxy/Btn'),

    VehicleLotAndDistance: Utils.loadComponent('entities/vehicle/VehicleLotAndDistance'),
    VehicleInstructions,
    VehicleQuickSummary,
    VehicleFeatures,
    VehicleFares,
  },
  name: 'VehicleDetail',
})
export default class VehicleDetail extends Vue {
  @Prop() protected vehicleSlot!: VehicleSlot
}
